import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { PostCard } from "../components/PostCard";
import SEO from "../components/SEO";

export default function Listing({ type, title, kicker, accent = "#D4FF00" }) {
  const params = useParams();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const categoryParam = params.tag ? decodeURIComponent(params.tag) : null;

  useEffect(() => {
    setLoading(true);
    const query = {};
    if (type) query.type = type;
    if (categoryParam) query.category = categoryParam;
    api
      .get("/posts", { params: query })
      .then((r) => setPosts(r.data))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [type, categoryParam]);

  const heading = categoryParam ? categoryParam : title;

  return (
    <div data-testid={`listing-${type || "category"}`} className="mx-auto max-w-[1400px] px-4 py-10 sm:px-6 sm:py-16 lg:px-12 lg:py-24">
      <SEO title={heading} description={`${heading} — Baseline Breakdown tennis coverage.`} />
      <div className="mb-8 border-b border-white/10 pb-8 sm:mb-12 sm:pb-10">
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] sm:text-xs" style={{ color: accent }}>{kicker}</div>
        <h1 className="mt-3 font-display text-4xl font-bold leading-[0.95] tracking-tighter text-white sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl">
          {heading}
        </h1>
        <p className="mt-4 max-w-xl text-sm text-white/60">
          {type === "article" && "Longform reporting, analysis, and opinion from the Baseline Breakdown desk."}
          {type === "podcast" && "Weekly conversations with the sharpest minds in tennis."}
          {type === "digital" && "Original film, tutorials, and visual storytelling."}
          {!type && `Everything tagged in ${categoryParam}.`}
        </p>
      </div>

      {loading && <div className="py-20 text-center text-sm uppercase tracking-[0.2em] text-white/40">Loading…</div>}
      {error && <div className="py-20 text-center text-sm text-red-400">{error}</div>}
      {!loading && posts.length === 0 && (
        <div className="py-20 text-center text-sm uppercase tracking-[0.2em] text-white/40">No posts yet.</div>
      )}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {posts.map((p) => <PostCard key={p.id} post={p} />)}
      </div>
    </div>
  );
}
